<script>
export default {
  props: {
    id: { type: String, required: true },
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    okButton: {
      type: String,
      default: function () {
        this.$t('general.save');
      },
    },
    cancelButton: {
      type: String,
      default: function () {
        this.$t('general.cancel');
      },
    },
  },
  data() {
    return {
      title2: '',
      message2: '',
      okButton2: '',
      cancelButton2: '',
      resolvePromise: null,
      rejectPromise: null,
    };
  },
  methods: {
    show(opts = {}) {
      this.title2 = opts.title;
      this.message2 = opts.message;
      this.okButton2 = opts.okButton;
      this.cancelButton2 = opts.cancelButton;

      this.$bvModal.show(this.id + '-confirmation-modal');

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },

    confirm() {
      this.$bvModal.hide(this.id + '-confirmation-modal');
      this.resolvePromise(true);
    },

    cancel() {
      this.$bvModal.hide(this.id + '-confirmation-modal');
      this.resolvePromise(false);
    },
  },
};
</script>

<template>
  <b-modal
    :id="id + '-confirmation-modal'"
    size="md"
    :title="title"
    ok-variant="primary"
  >
    <template #modal-footer>
      <b-button @click="cancel()" size="md" variant="secondary">
        {{ cancelButton }}
      </b-button>
      <b-button @click="confirm()" size="md" variant="primary">
        {{ okButton }}
      </b-button>
    </template>
  </b-modal>
</template>